import React from 'react'
import WOW from '../img/projects/WeightofWaters/WOW.JPG'
import we from '../img/projects/WeightofWaters/we.png'
import decolonization from '../img/projects/WeightofWaters/decolonization.png'
import { motion } from 'framer-motion'
import { transition1 } from '../transitions'
import { AiFillEye } from "react-icons/ai";
import { useNavigate } from 'react-router-dom'

const Gallery = () => {

  const images = [
    { src: WOW, alt: 'weightOfWaters', link: "/WeightofWaters-album" },
    { src: we, alt: 'weCollective' , link: "/WeCollective-album" },
    { src: decolonization, alt: 'decolonization', link: "/MappingGeographiesofPower-album" },
  ]

  const navigate = useNavigate();

  return (
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='pb-20 px-4 pt-32 sm:px-8 lg:pt-36 overflow-auto mb-44 lg:mb-0'
    >
      <div className='max-w-6xl mx-auto'>
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6'>
          {images.map((image, index) => (
            <div onClick={() => navigate(image.link)} key={index} className='relative group overflow-hidden rounded-lg shadow-md'>
              <img
                className='w-full h-auto object-cover transition-transform duration-300 group-hover:scale-105'
                src={image.src}
                alt={image.alt}
              />
              <div className='absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300 bg-black bg-opacity-40 cursor-pointer'>
                <AiFillEye className='text-white text-4xl sm:text-5xl' />
              </div>
            </div>
          ))}
        </div>
      </div>
    </motion.section>
  )
}

export default Gallery
